"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipRail = exports.railCenterStyle = exports.railStyle = void 0;
const react_1 = __importDefault(require("react"));
exports.railStyle = {
    position: 'absolute',
    width: '100%',
    height: '30px',
    borderRadius: 7,
    cursor: 'pointer',
    opacity: 0.3,
    zIndex: 300,
};
exports.railCenterStyle = {
    position: 'absolute',
    width: '100%',
    height: '3px',
    top: '13px',
    borderRadius: '7px',
    cursor: 'pointer',
    pointerEvents: 'none',
    backgroundColor: 'rgb(155,155,155)',
};
const TooltipRail = props => {
    const { getRailProps } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", Object.assign({ "data-id": "rail", style: exports.railStyle }, getRailProps())),
        react_1.default.createElement("div", { "data-id": "rail-center", style: exports.railCenterStyle })));
};
exports.TooltipRail = TooltipRail;
//# sourceMappingURL=TooltipRail.js.map